import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button as ButtonMui} from "@mui/material";
import {Box} from "grommet";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";
import {colors} from "../../utilis/theme.js";

const config = {
  success: {icon: CheckCircleIcon, color: colors.success, bg: 'rgba(46, 125, 50, 0.08)'},
  error: {icon: ErrorIcon, color: colors.error, bg: 'rgba(211, 47, 47, 0.08)'},
  warning: {icon: WarningIcon, color: '#ed6c02', bg: 'rgba(237, 108, 2, 0.08)'},
};

export default function AlertDialog({open, onClose, message, type = "success"}) {
  const {icon: Icon, color, bg} = config[type] || config.success;

  React.useEffect(() => {
    if (open && type === "success") {
      const timer = setTimeout(onClose, 2000);
      return () => clearTimeout(timer);
    }
  }, [open, type]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {borderRadius: '16px', minWidth: '360px', overflow: 'hidden'}
      }}
    >
      <DialogContent sx={{textAlign: 'center', pt: 4, pb: 2, backgroundColor: bg}}>
        <Icon sx={{fontSize: 56, color: color, mb: 1}} />
        <Box style={{fontSize: '16px', fontWeight: 500, color: colors.textPrimary}}>
          {message}
        </Box>
      </DialogContent>
      <DialogActions sx={{justifyContent: 'center', pb: 3, backgroundColor: bg}}>
        <ButtonMui
          variant="contained"
          onClick={onClose}
          sx={{
            borderRadius: '8px', textTransform: 'none', minWidth: '100px',
            backgroundColor: color,
            '&:hover': {backgroundColor: color, filter: 'brightness(0.9)'}
          }}
        >
          OK
        </ButtonMui>
      </DialogActions>
    </Dialog>
  );
}
